<!-- 组件说明 -->
<template>
  <!-- <div> -->
    <!-- <div v-for="(item,index) in categoryList" :key="index">
        {{ item.categoryName }} -->
    <!--把列表写个组件（商品列表带分页的组件）, -->
    <!-- <goodsList :type='item.categoryName' ></goodsList> -->

    <!-- 这块代码写到组件里 -->
    <!-- <div  style="font-size:20px;text-align:center;padding:10px">
        <span>{{item.categoryName}}</span>
      </div> -->
    <div class="listItem">
      <div class="listItems" v-for="(item, index) in listItem" :key="index">
         <router-link :to="'/CategoryDetail/' + item.country +'_'+ item.prodId">
          <div class="items">
            <img :src="item.pic+ process" alt="" class="item_img" />
          </div>
          <div class="items_prodName">
            {{ item.prodName }}
          </div>
          <div class="items-money">
            {{ $t("Pay.money") }}{{ item.price }}
          </div>
         </router-link>
      </div>
      <div class="pagination" ><van-pagination v-model="currentList.current" :total-items="total" :page-count="currentList.pages" @change="pagination(currentList.records[0].categoryId,0,currentList.current)">
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
        </van-pagination>
      </div>
    </div>
  <!-- </div> -->
  <!-- </div>
  </div> -->
</template>

<script>
import {Icon,Toast, Loading,Pagination } from 'vant';
import home from "@/api/home";
import goods from "@/api/goods";
export default {
  name: "indexItem",
  components: {},
  data() {
    return {
      color:'#red',
      categoryList: [],
      listItem: [],
      currentList:[
      ],
      total:null,
      current:1,
      pages:10,
      loading:false,
      list:this.datas
    };
  },
  props: {
    datas: {
      type: Object,
      // type: Array,
      default: function () {
        // return [];
      }
    },
  },
  watch:{
    datas: {
      handler(newValue, oldValue) { 
      //  newValue.forEach((item, index) => {
      //     this.getPageList(item.categoryId,item.shopId)
      //   });
       this.getPageList(newValue.categoryId,newValue.shopId)
      }, 
      immediate:true,
    }
  },
  computed: {

  },
  methods: {
    goDetail(prodId){
      // this.$router.push({name:'CategoryDetail'})
      // console.log(prodId)
      this.$router.push({
        name:'GoodsCategoryDetail',
        query: {CategoryDetail:prodId}
      })
    },
    pagination(categoryId,shopid,current){
        Toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
        });
        let shodId = shopid
        shodId = sessionStorage.getItem('shopId')
        this.getPageList(categoryId,shodId,current)
    },
    getPageList(categoryId,shopId,id){
        let params = {
            categoryId: categoryId,
            shopId: shopId,
            current:id,
            size:8,
        }
        goods.pageProd(params).then((res) => {
          // debugger
            Toast.clear();
            this.listItem = res.records;
            this.currentList = res
        });
    }
    
  },
  computed: {
  },
  created() {
    // debugger
    let clientWidth = document.documentElement.clientWidth + 250;
    this.clientWidth = clientWidth;
    this.process = "?x-oss-process=image/resize,w_" + clientWidth;
    // let list = [];
    // list.push(this.datas);
    // console.info('this.datas',this.datas)
    // list.forEach((item, index) => {
    //   this.getPageList(item.categoryId,item.shopId)
    // });
        // this.list.forEach((item, index) => {
        //   this.getPageList(item.categoryId,item.shopId)
        // });
    //   this.datas.

    //生命周期 - 创建完成
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped='scoped'>
.van-swipe {
  min-height: 175px;
  // height: 500px;
  max-height: 374;
}
.listItem {
  display: flex;
  flex-wrap: wrap;
}
.listItem .listItems {
  width: 50%;
}
.items{
  padding: 0 10px;
}
.item_img {
  // width: 150px;
  // height: 150px;
  // padding: 20px;
  min-width: 100%;
  min-height: auto;
  border-radius: 5px;
  // padding:0 10px;
//   padding: 20px;
  /* max-width: 300px; */
  // height: 300px;
}
@media screen and (max-width: 768px) {
  .van-swipe {
    height: 175px;
  }
  .item_img {
    width:100%;
    height:185px;
    // padding:0 10px;
    // padding: 20px 15px;
  }
}
@media screen and (min-width: 1110px){
  .listItem .listItems {
    width: 24%;
    padding: 0.5%;
  }
  .item_img {
    height: 180px;
  }
  .listItem .listItems .items_img:hover {
    // filter:alpha(Opacity=100);
    // -moz-opacity:0.8;
    // opacity: 0.8
    
    filter:alpha(Opacity=20);
    color: red;
    -moz-opacity:0.7;
    opacity: 0.7;
  }
}
.pagination{
  width:100%;
  text-align:center;
}
.items_img{
  display: flex;
  justify-content: center;
  align-items: center
}
.items_prodName{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; 
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-align: center;
  padding: 0px 20px;
  font-size:13px;
  margin: 10px 0 0;
  font-family: 'bootstrap';
}
.items-money{
  padding: 5px 20px 10px;
   text-align: center;
   font-size: 16px;
   font-weight: bold;
   color: #C74060;
}
.pagination >>> .van-pagination__item--active{
  background: #C74060;
  color: #fff !important;

}
.pagination >>> .van-pagination__item{
  color: #C74060;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index2.vue